import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "createStrategyModal",
  tabindex: "-1",
  "aria-labelledby": "createStrategyModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content text-start" }
const _hoisted_4 = { class: "modal-body text-start" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = { class: "modal-footer text-start" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "modal-header custom-modal-header text-start" }, [
          _createElementVNode("h5", {
            class: "modal-title",
            id: "createStrategyModalLabel"
          }, " Create New Strategy "),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createStrategy && _ctx.createStrategy(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "strategyName",
                class: "form-label"
              }, "Strategy Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "strategyName",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.strategy.name) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.strategy.name]
              ]),
              (_ctx.isNameNotValid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Strategy with such name already exists. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                for: "priceRounding",
                class: "form-label"
              }, "Price Rounding", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                id: "priceRounding",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.strategy.roundingTypeId) = $event))
              }, [...(_cache[8] || (_cache[8] = [
                _createStaticVNode("<option value=\"0\" data-v-24eb9656>To nearest cent</option><option value=\"1\" data-v-24eb9656>To nearest dollar</option><option value=\"2\" data-v-24eb9656>To nearest 99c</option><option value=\"3\" data-v-24eb9656>To nearest higher dollar</option><option value=\"4\" data-v-24eb9656>To nearest higher 99c</option>", 5)
              ]))], 512), [
                [_vModelSelect, _ctx.strategy.roundingTypeId]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label d-block" }, [
                _createElementVNode("i", { class: "bi bi-calendar3" }),
                _createTextVNode(),
                _createElementVNode("b", null, "Price by Days in Advance")
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "isMultipleWindows",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.strategy.isMultipleWindows) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.strategy.isMultipleWindows]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "isMultipleWindows"
                }, " Adjust the price based on number of days-out ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label d-block" }, [
                _createElementVNode("b", null, "% Price by Tee Sheet Utilization")
              ], -1)),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "adjustByUtilization",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.strategy.isAdjustByUtilization) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.strategy.isAdjustByUtilization]
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "adjustByUtilization"
                }, " Adjust the price as the tee sheet fills ", -1))
              ])
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createStrategy && _ctx.createStrategy(...args))),
            disabled: _ctx.isNameNotValid || !_ctx.isFormValid
          }, " Create ", 8, _hoisted_13)
        ])
      ])
    ])
  ]))
}